<template>
  <div id="dash-hidden">
    <input type="hidden" name="getvzyear_url"       v-model="getvzyear_url">
    <input type="hidden" name="timeout_url"         v-model="timeout_url">
    <input type="hidden" name="license_url"         v-model="license_url">
    <input type="hidden" id="lov_url"      			    v-model="lov_url">
    <input type="hidden" id="logicstmt_url"      	  v-model="logicstmt_url">
    <input type="hidden" id="filedump"              v-model="filedump">
    <input type="hidden" id="display_remark_appr" 	v-model="display_remark_appr">
    <input type="hidden" id="production_site" 			v-model="production_site">
    <input type="hidden" id="global_lang"           v-model="lang">
    <input type="hidden" id="symbol_slash"          v-model="symbol_slash">

    <div class="page-option">
      <div class="back-top" draggable="true">
        <a href="#" title="Back To Top"><span></span></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dash-hidden',
  data () {
    return {
      getvzyear_url: 'vzyear.get',
      timeout_url: 'login.get',
      license_url: 'home.get',
      lov_url: 'lov.ajaxcenter.post',
      logicstmt_url: 'LogicalStmt.ajaxcenter.get',
      filedump: 'api.fd.get',
      display_remark_appr: true,
      production_site: 'STA3',
      lang: 'en',
      symbol_slash: '/'
    }
  }
}
</script>


// WEBPACK FOOTER //
// DashHidden.vue?58bf4d07